import { Box, HStack, Text, VStack } from 'native-base'

import { colors } from '../../utils/theme/configureTheme'
import { ISSUE_TYPE_LABELS } from '../ReportIssue/types'
import { IssueType, SubmissionBodyProps } from './types'

/** Body of the issue submission confirmation screen showing issue details and next steps. */
export default function SubmissionBody({
  issueId,
  imageData,
  issueType,
  issueDetail,
  name,
  email,
  cellPhone,
}: SubmissionBodyProps) {
  const getIssueTypeLabel = (type: IssueType): string => {
    return ISSUE_TYPE_LABELS[type] || ''
  }

  return (
    <VStack space={4} width="100%">
      <Text fontSize={12} fontWeight={400} color={colors.brand.darkGrey} lineHeight="125%">
        Issue #{issueId}
      </Text>
      <Box height="1px" width="100%" backgroundColor={colors.brand.lightGrey} />
      <HStack space={3} alignItems="flex-start">
        {imageData?.dataUrl && (
          <Box>
            <img
              src={imageData?.dataUrl || ''}
              alt="IssuePhoto"
              style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
            />
          </Box>
        )}
        <VStack flex={1} space={1}>
          <Text
            fontSize={10}
            fontWeight={700}
            color={colors.brand.darkGrey}
            lineHeight="125%"
            letterSpacing={'2%'}
            textTransform="uppercase"
            mb={1}
            fontFamily="Matter Regular"
          >
            MY ISSUE
          </Text>
          <Text
            fontSize={14}
            fontWeight={700}
            color={colors.brand.softBlack}
            lineHeight="125%"
            letterSpacing={'-1%'}
            fontFamily="Matter SemiBold"
          >
            {getIssueTypeLabel(issueType)}
          </Text>
          {issueDetail && (
            <Text
              fontSize={14}
              fontWeight={400}
              color={colors.brand.softBlack}
              lineHeight="125%"
              letterSpacing={'-1%'}
              fontFamily="Matter Regular"
            >
              {issueDetail}
            </Text>
          )}
        </VStack>
      </HStack>
      {(name || email || cellPhone) && (
        <>
          <Box height="1px" width="100%" backgroundColor={colors.brand.lightGrey} />
          <VStack space={1}>
            <Text
              fontSize={10}
              fontWeight={700}
              color={colors.brand.darkGrey}
              lineHeight="125%"
              textTransform="uppercase"
              letterSpacing={'2%'}
              fontFamily="Matter Regular"
              mb={1}
            >
              CONTACT INFORMATION
            </Text>
            {name && (
              <Text
                fontSize={14}
                fontWeight={400}
                color={colors.brand.softBlack}
                lineHeight="125%"
                letterSpacing={'-1%'}
                fontFamily="Matter Regular"
              >
                {name}
              </Text>
            )}
            {email && (
              <Text
                fontSize={14}
                fontWeight={400}
                color={colors.brand.softBlack}
                lineHeight="125%"
                letterSpacing={'-1%'}
                fontFamily="Matter Regular"
              >
                {email}
              </Text>
            )}
            {cellPhone && (
              <Text
                fontSize={14}
                fontWeight={400}
                color={colors.brand.softBlack}
                lineHeight="125%"
                letterSpacing={'-1%'}
                fontFamily="Matter Regular"
              >
                {cellPhone}
              </Text>
            )}
          </VStack>
        </>
      )}
    </VStack>
  )
}
